export const PRESCRIPTION_FIELDS = [
  'drug_code',
  'drug_name',
  'specification',
  'administration_route',
  'frequency',
  'single_dose'
];

export const createEmptyPrescriptionDraft = () => ({
  drug_code: '',
  drug_name: '',
  specification: '',
  administration_route: '',
  frequency: '',
  single_dose: ''
});

export const preparePrescriptionDrafts = (drafts = []) => {
  const items = [];
  const incompleteRows = [];

  drafts.forEach((draft, index) => {
    const normalized = PRESCRIPTION_FIELDS.reduce((item, field) => ({
      ...item,
      [field]: String(draft?.[field] || '').trim()
    }), {});
    const hasValue = PRESCRIPTION_FIELDS.some((field) => normalized[field]);
    if (!hasValue) {
      return;
    }

    const missingFields = PRESCRIPTION_FIELDS.filter((field) => !normalized[field]);
    if (missingFields.length > 0) {
      incompleteRows.push({ index, missingFields });
      return;
    }
    items.push(normalized);
  });

  return {
    items,
    incompleteRows,
    hasIncompleteRows: incompleteRows.length > 0
  };
};
